export class DocumentType {
  id: number;
  intranet_id: number;
  parent_id: number;
  prefix: string;
  name: string;
  is_active: boolean = true;
  description: string;
  is_check: boolean;
  is_email: boolean;
  ancestry: any;
  is_expense: boolean = false;
  loading: boolean = false;
  children: Array<DocumentType> = [];
  parent: DocumentType;
  expanded: boolean = false;
  prefix_letter: string;
}
